import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/pages/ProductPage.tsx");
